import React, { useEffect, useState } from 'react'
import { Marker, GeoJSON } from 'react-leaflet'
import L from 'leaflet'

// Add CSS styles for custom labels
const labelStyles = `
  .custom-label {
    background: transparent !important;
    border: none !important;
  }

  .custom-label div {
    background-color: transparent !important;
    color: #333 !important;
    padding: 0 !important;
    border-radius: 0 !important;
    font-weight: 100 !important;
    text-align: center !important;
    white-space: nowrap !important;
    border: none !important;
    box-shadow: none !important;
    pointer-events: none !important;
    z-index: 1000 !important;
    font-family: Arial, sans-serif !important;
    line-height: 1.2 !important;
  }
`;

// Helper function to calculate center point of a polygon
const getPolygonCenter = (coordinates) => {
    if (!coordinates || !coordinates[0] || coordinates[0].length === 0) {
        return [0, 0]
    }

    const points = coordinates[0]
    let sumLat = 0
    let sumLng = 0

    points.forEach(point => {
        sumLat += point[1] // latitude
        sumLng += point[0] // longitude
    })

    return [sumLat / points.length, sumLng / points.length]
}

// Helper function to create label icon
const createLabelIcon = (text, zoomLevel) => {
    const fontSize = Math.max(5, Math.min(10, 10 + zoomLevel * 0.6)) // Reduced font size range
    // Dynamic font size based on zoom
    // console.log('fontSize =>', fontSize)
    const name = String(text || '').trim()
    return L.divIcon({
        className: 'custom-label',
        html: `<div style="
      background-color: transparent;
      color: 'grey';
      padding: 0;
      border-radius: 0;
      font-size: ${fontSize}px;
      font-weight: 80;
      text-align: center;
      white-space: nowrap;
      border: none;
      box-shadow: none;
      pointer-events: none;
      z-index: 1000;
    ">${name}</div>`,
        iconSize: [0, 0],
        iconAnchor: [0, 0]
    });
}

function GeoJSONLabels({ zoom, minZoomLevel = 17, geoJSONPath = '/geo/ahm.geojson' }) {
    const [labelMarkers, setLabelMarkers] = useState([]);
    const [geoJSONData, setGeoJSONData] = useState(null);

    // Load GeoJSON file from public folder
    useEffect(() => {
        const loadGeoJSON = async () => {
            try {
                const response = await fetch(geoJSONPath);
                if (response.ok) {
                    // console.log('response =>', response)
                    const data = await response.json();
                    setGeoJSONData(data);
                } else {
                    console.error('Failed to load GeoJSON file');
                }
            } catch (error) {
                console.error('Error loading GeoJSON:', error);
            }
        };

        loadGeoJSON();
    }, [geoJSONPath]);

    // Create label markers when GeoJSON data changes or zoom changes
    useEffect(() => {
        if (geoJSONData && geoJSONData.features) {
            const markers = geoJSONData.features
                .filter(feature => feature.properties && feature.properties.name)
                .map(feature => {
                    const center = getPolygonCenter(feature.geometry.coordinates);
                    return {
                        position: center,
                        text: feature.properties.name,
                        zoom: zoom
                    };
                });
            setLabelMarkers(markers);
        }
    }, [geoJSONData, zoom]);

    return (
        <>
            <style>{labelStyles}</style>

            {/* Render the GeoJSON polygons */}
            {geoJSONData && (
                <GeoJSON
                    data={geoJSONData}
                    style={{ color: 'grey', weight: 1 }}
                />
            )}

            {/* Render label markers */}
            {/* {console.log('zoom =>', zoom)} */}
            {labelMarkers.map((labelMarker, index) => (
                zoom >= minZoomLevel && (
                    <Marker
                        key={`label-${index}-${labelMarker.zoom}`}
                        position={labelMarker.position}
                        icon={createLabelIcon(labelMarker.text, labelMarker.zoom)}
                    />
                )
            ))}
        </>
    );
}

export default GeoJSONLabels; 
